import { QueryClient } from "@tanstack/react-query";

/**
 * Singleton QueryClient. Tuned for an Event OS workload:
 *   - 1 min staleTime: avoids hammering the backend on every component remount.
 *   - retry: 1: most fetches go to our own API with a known surface — fail fast.
 *   - refetchOnWindowFocus: false: irritating in admin tables; opt-in per query.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
